import React from 'react';
import { motion } from 'framer-motion';

const PoliticalIllustrations = () => {
  // Professional Political Leader Illustrations
  const PoliticalLeader1 = () => (
    <svg width="200" height="240" viewBox="0 0 200 240" className="drop-shadow-lg">
      {/* Background Circle */}
      <circle cx="100" cy="120" r="90" fill="url(#gradient1)" opacity="0.1"/>
      
      {/* Body/Suit */}
      <rect x="70" y="140" width="60" height="80" rx="8" fill="#1e40af"/>
      <rect x="75" y="145" width="50" height="70" rx="6" fill="#2563eb"/>
      
      {/* Shirt */}
      <rect x="80" y="150" width="40" height="60" rx="4" fill="#ffffff"/>
      
      {/* Tie */}
      <polygon points="95,155 105,155 108,190 92,190" fill="#dc2626"/>
      
      {/* Head */}
      <circle cx="100" cy="110" r="25" fill="#d4a574"/>
      
      {/* Hair */}
      <path d="M 75 95 Q 100 80 125 95 Q 120 85 100 85 Q 80 85 75 95" fill="#2d3748"/>
      
      {/* Eyes */}
      <circle cx="92" cy="105" r="3" fill="#000"/>
      <circle cx="108" cy="105" r="3" fill="#000"/>
      <circle cx="93" cy="104" r="1" fill="#fff"/>
      <circle cx="109" cy="104" r="1" fill="#fff"/>
      
      {/* Nose */}
      <ellipse cx="100" cy="112" rx="2" ry="3" fill="#c69963"/>
      
      {/* Mouth - Confident Smile */}
      <path d="M 94 118 Q 100 122 106 118" stroke="#8b4513" strokeWidth="2" fill="none"/>
      
      {/* Arms */}
      <rect x="55" y="150" width="15" height="40" rx="7" fill="#1e40af"/>
      <rect x="130" y="150" width="15" height="40" rx="7" fill="#1e40af"/>
      
      {/* Hands */}
      <circle cx="62" cy="195" r="8" fill="#d4a574"/>
      <circle cx="138" cy="195" r="8" fill="#d4a574"/>
      
      {/* Indian Flag Pin */}
      <rect x="85" y="155" width="8" height="6" fill="#ff9933"/>
      <rect x="85" y="161" width="8" height="6" fill="#ffffff"/>
      <rect x="85" y="167" width="8" height="6" fill="#138808"/>
      
      <defs>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3b82f6"/>
          <stop offset="100%" stopColor="#1e40af"/>
        </linearGradient>
      </defs>
    </svg>
  );

  const PoliticalLeader2 = () => (
    <svg width="200" height="240" viewBox="0 0 200 240" className="drop-shadow-lg">
      {/* Background Circle */}
      <circle cx="100" cy="120" r="90" fill="url(#gradient2)" opacity="0.1"/>
      
      {/* Saree/Traditional Dress */}
      <path d="M 70 140 Q 100 135 130 140 L 135 220 L 65 220 Z" fill="#dc2626"/>
      <path d="M 70 140 Q 100 135 130 140 L 130 160 L 70 160 Z" fill="#ff9933"/>
      
      {/* Blouse */}
      <rect x="80" y="140" width="40" height="30" rx="4" fill="#2563eb"/>
      
      {/* Head */}
      <circle cx="100" cy="110" r="25" fill="#d4a574"/>
      
      {/* Hair - Traditional Style */}
      <path d="M 75 95 Q 100 75 125 95 Q 125 100 120 105 Q 100 90 80 105 Q 75 100 75 95" fill="#1a202c"/>
      <circle cx="100" cy="95" r="3" fill="#fbbf24"/> {/* Hair ornament */}
      
      {/* Eyes */}
      <circle cx="92" cy="105" r="3" fill="#000"/>
      <circle cx="108" cy="105" r="3" fill="#000"/>
      <circle cx="93" cy="104" r="1" fill="#fff"/>
      <circle cx="109" cy="104" r="1" fill="#fff"/>
      
      {/* Bindi */}
      <circle cx="100" cy="98" r="2" fill="#dc2626"/>
      
      {/* Nose */}
      <ellipse cx="100" cy="112" rx="2" ry="3" fill="#c69963"/>
      
      {/* Mouth - Warm Smile */}
      <path d="M 94 118 Q 100 123 106 118" stroke="#8b4513" strokeWidth="2" fill="none"/>
      
      {/* Arms */}
      <rect x="55" y="150" width="15" height="40" rx="7" fill="#dc2626"/>
      <rect x="130" y="150" width="15" height="40" rx="7" fill="#dc2626"/>
      
      {/* Hands with Namaste gesture */}
      <ellipse cx="100" cy="180" rx="12" ry="8" fill="#d4a574"/>
      
      {/* Jewelry */}
      <rect x="95" y="140" width="10" height="3" rx="1" fill="#fbbf24"/>
      
      <defs>
        <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#dc2626"/>
          <stop offset="100%" stopColor="#991b1b"/>
        </linearGradient>
      </defs>
    </svg>
  );

  const PoliticalLeader3 = () => (
    <svg width="200" height="240" viewBox="0 0 200 240" className="drop-shadow-lg">
      {/* Background Circle */}
      <circle cx="100" cy="120" r="90" fill="url(#gradient3)" opacity="0.1"/>
      
      {/* Kurta */}
      <rect x="70" y="140" width="60" height="80" rx="8" fill="#ffffff"/>
      <rect x="75" y="145" width="50" height="70" rx="6" fill="#f8fafc"/>
      
      {/* Nehru Jacket */}
      <rect x="75" y="145" width="50" height="50" rx="6" fill="#1f2937"/>
      
      {/* Head */}
      <circle cx="100" cy="110" r="25" fill="#d4a574"/>
      
      {/* Hair - Distinguished */}
      <path d="M 75 95 Q 100 80 125 95 Q 120 85 100 85 Q 80 85 75 95" fill="#6b7280"/>
      
      {/* Eyes */}
      <circle cx="92" cy="105" r="3" fill="#000"/>
      <circle cx="108" cy="105" r="3" fill="#000"/>
      <circle cx="93" cy="104" r="1" fill="#fff"/>
      <circle cx="109" cy="104" r="1" fill="#fff"/>
      
      {/* Glasses */}
      <circle cx="92" cy="105" r="8" fill="none" stroke="#374151" strokeWidth="2"/>
      <circle cx="108" cy="105" r="8" fill="none" stroke="#374151" strokeWidth="2"/>
      <line x1="100" y1="105" x2="100" y2="105" stroke="#374151" strokeWidth="2"/>
      
      {/* Nose */}
      <ellipse cx="100" cy="112" rx="2" ry="3" fill="#c69963"/>
      
      {/* Mouth - Wise Smile */}
      <path d="M 94 118 Q 100 121 106 118" stroke="#8b4513" strokeWidth="2" fill="none"/>
      
      {/* Arms */}
      <rect x="55" y="150" width="15" height="40" rx="7" fill="#1f2937"/>
      <rect x="130" y="150" width="15" height="40" rx="7" fill="#1f2937"/>
      
      {/* Hands */}
      <circle cx="62" cy="195" r="8" fill="#d4a574"/>
      <circle cx="138" cy="195" r="8" fill="#d4a574"/>
      
      {/* Gandhi Cap */}
      <path d="M 80 95 Q 100 85 120 95 L 115 90 Q 100 80 85 90 Z" fill="#ffffff"/>
      
      <defs>
        <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10b981"/>
          <stop offset="100%" stopColor="#059669"/>
        </linearGradient>
      </defs>
    </svg>
  );

  const TrustBadge = () => (
    <motion.div 
      className="flex items-center justify-center space-x-4 bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-6 border border-green-200"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, delay: 0.5 }}
    >
      <div className="text-4xl">🏛️</div>
      <div className="text-center">
        <h3 className="text-2xl font-bold text-gray-900 mb-1">110% Trust</h3>
        <p className="text-green-600 font-semibold">in Jet Digital Infotech</p>
        <p className="text-sm text-gray-600">Trusted by Leaders Across India</p>
      </div>
      <div className="text-4xl">🇮🇳</div>
    </motion.div>
  );

  return {
    PoliticalLeader1,
    PoliticalLeader2,
    PoliticalLeader3,
    TrustBadge
  };
};

export default PoliticalIllustrations;
